































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IProperty } from "../../models/interfaces/property/property.model.interface";

import Loader from "@/components/Loader.vue";

const ProductModule = namespace("productModule");
const PropertyManagementModule = namespace("propertyManagementModule");

@Component({
  components: {
    Loader
  }
})
export default class PropertyProductCategories extends Vue {
  @ProductModule.Action public retrieveProductCategories;
  @ProductModule.Getter public productCategories;

  @PropertyManagementModule.Action public addProductCategory;
  @PropertyManagementModule.Action public removeProductCategory;

  get getProperty(): IProperty {
    return this.property;
  }

  get loadingStatus(): boolean {
    return this.loading || this.internalLoading;
  }

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop() public property: IProperty;

  @Prop() public loading: boolean;

  @Provide() public itemToRemove: number | null = null;

  @Provide() public itemToAdd: number | null = null;

  @Provide() public options: any[] = [];

  @Provide() public newItems: any[] = [];

  @Provide() public existingItems: any[] = [];

  @Provide()
  public columns = [
    {
      key: "text",
      label: "Product Category"
    },
    {
      key: "actions",
      label: "Delete",
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  private show: boolean = false;

  private internalLoading: boolean = false;

  @Watch("getProperty", { deep: true })
  public onPropertyUpdate() {
    this.updateItems();
  }

  public showModal(itemId: number) {
    this.itemToRemove = itemId;
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

  public loadOptions() {
    this.retrieveProductCategories().then((result) => {
      if (result) {
        this.options = this.productCategories.map((val) => ({
          value: val.productCategoryId,
          text: val.name
        }));
      }
    });
  }

  public updateItems() {
    this.itemToAdd = null;

    const current = this.property.permittedCategories.map((x) => x.productCategoryId);

    this.newItems = this.options.filter((x) => !current.includes(x.value));
    this.existingItems = this.options.filter((x) => current.includes(x.value));
  }

  public addItem() {
    if (this.itemToAdd) {
      this.addProductCategory(this.itemToAdd);
    }
  }

  public removeItem() {
    if (this.itemToRemove && this.itemToRemove > 0) {
      this.removeProductCategory(this.itemToRemove).then((result) => {
        if (result) {
          this.show = false;
          this.updateItems();
        }
      });
    }
  }

  public created() {
    this.loadOptions();
    this.updateItems();
  }
}
